module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-all-japan.9d2758aa.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-all-japan.png
// module id = 2617
// module chunks = 11